module.exports = __webpack_public_path__ + "static/media/IOTA-BNB.13b90ad2.svg";